import createActionTypes from './createActionTypes';

export const namespace = 'ROUTER_MATCH';

export const types = createActionTypes(namespace, ['UPDATE_ROUTER_MATCH']);

export const updateRouterMatch = (match) => ({
  type: types.UPDATE_ROUTER_MATCH,
  payload: {
    match,
  },
});
